import type { ChartSpec } from '../types';
import { icon } from './Icon';

export function ChartPanel(spec: ChartSpec, span: string, small = false, recHint = ''): string {
  const clickable = spec.recommendations?.length
    ? `class="panel-title clickable" data-rec="chart:${spec.id}" role="button" tabindex="0" title="${recHint}"`
    : 'class="panel-title"';
  return `
  <div class="panel ${span}">
    <h3 ${clickable}>${icon(spec.icon)} <span>${spec.title}</span>${spec.recommendations?.length ? `<span class="rec-badge">${icon('lightbulb', 'icon icon-xs')}</span>` : ''}</h3>
    <div class="sub">${spec.subtitle}</div>
    <div class="chartbox ${small ? 'sm' : ''}"><canvas id="chart-${spec.id}" role="img" aria-label="${spec.title}"></canvas></div>
  </div>`;
}
